import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

import { massiveDocumentCreate } from "./massiveDocumentCreate";
import { documentUpdate } from "./documentUpdate";
import { combineReducers } from "@reduxjs/toolkit";
import { paymentNoticesList } from "./paymentNoticesList";
import userAuthentication from "./userAuthentication/userAuthentication.reducer";
import clients from "./clients/clients.reducer";
import account from "./account/account.reducer";
import { paymentNoticeDetail } from "./paymentNoticeDetail";
import { documentsList } from "./documentList";
import { documentCreate } from "./documentCreate";
import { documentShow } from "./documentShow";

import users from "./users";
import profilesList from "./profilesList/profilesList.reducer";
import profileForm from "./profileForm/profileForm.reducer";
import profileDetail from "./profileDetail/profileDetail.reducer";
import utils from "./utils";
import notificationsList from "./notificationsList";
import fichaMiDt from "./fichaMiDt";
import userShow from "./userShow";
import userCreate from "./userCreate";
import { documentSignerShow } from "./documentSignerShow";
import documentsSignerList from "./documentsSignerList";
import userUpdate from "./userUpdate";
import templateCreate from "./templateCreate";
import templateDetail from "./templateDetail";
import templateList from "./templateList";
import locations from "./locations";
import locationShow from "./locationShow";
import organizations from "./organizations";
import organizationShow from "./organizationShow";
import supervisorHome from "./supervisorHome";
import { documentSupervisorShow } from "./documentSupervisorShow";
import userProfileLocation from "./userProfileLocation";
import userProfileOrganization from "./userProfileOrganization";
import { requiredDocumentShow } from "./requiredDocuments";
import formSubmittedSlice from "./formsubmitted";
import profileFormAssigned from "./profileFormAssigned";
import attendance from "./attendance";
import signatureProviders from "./signatureProviders";
import { supervisorDocumentsList } from "./supervisorRequiredDocuments";
import qrScanner from "./qrScanner";
import fileTypes from "./fileTypes";
import userTemplate from "./userTemplate";
import massNotification from "./MassNotification";
import {archiveShow} from "./archiveShow";

const persistentConfig = {
  userAuthentication: {
    key: "userAuthentication",
    storage: storage,
  },
  userShow: {
    key: "userShow",
    storage: storage,
  },
  users: {
    key: "users",
    storage: storage,
  },
};


const rootReducer = combineReducers({
  users: persistReducer(persistentConfig.users, users),
  userShow: persistReducer(persistentConfig.userShow, userShow),
  userUpdate,
  userCreate,
  userAuthentication: persistReducer(persistentConfig.userAuthentication, userAuthentication),
  userProfileLocation,
  userProfileOrganization,
  documentsList,
  documentShow,
  documentsSignerList,
  documentSignerShow,
  documentCreate,
  documentUpdate,
  paymentNoticesList,
  paymentNoticeDetail,
  clients,
  account,
  utils,
  profilesList,
  profileForm,
  profileFormAssigned,
  profileDetail,
  notificationsList,
  fichaMiDt,
  templateCreate,
  templateDetail,
  templateList,
  formSubmittedSlice,
  locations,
  locationShow,
  organizations,
  organizationShow,
  supervisorHome,
  documentSupervisorShow,
  massiveDocumentCreate,
  requiredDocumentShow,
  attendance,
  signatureProviders,
  supervisorDocumentsList,
  qrScanner,
  fileTypes,
  userTemplate,
  massNotification,
  archiveShow,
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
